import { motion } from 'framer-motion';
import { css, styled } from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Wrapper = styled(motion.div)`
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);

    border-radius: 100px;
    background: #523df1;
    box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.6);

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 10px 10px 20px;

    width: 100%;
    max-width: 294px;
`;

export const CheckboxCircle = styled.div<{ $isChecked?: boolean }>`
    width: 20px;
    height: 20px;
    border-radius: 100px;
    border: 2px solid #fff;

    display: flex;
    align-items: center;
    justify-content: center;
    color: #523df1;

    transition: background-color 0.2s ease-in-out;

    svg {
        width: 12px;
        transition: transform 0.2s ease-in-out;
        transform: scale(0);
    }

    ${({ $isChecked }) =>
        $isChecked &&
        css`
            background-color: #fff;
            svg {
                transform: scale(1);
            }
        `}
`;

export const SelectLabel = styled.button`
    ${styledReset.button}

    display: flex;
    align-items: center;
    gap: 10px;

    color: #fff;
    font-size: 14px;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: -0.14px;
    text-decoration: underline;
`;

export const ActionButton = styled.button`
    ${styledReset.button}

    background: #fff;
    border-radius: 100px;

    color: #0a0a0a;
    font-size: 14px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.28px;

    display: flex;
    align-items: center;
    gap: 8px;

    height: 40px;
    padding: 8px 8px 8px 16px;
`;

export const Count = styled.span`
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.12px;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 24px;
    height: 24px;

    background: #523df1;
    border-radius: 100px;
`;
